import { connect } from 'react-redux'
import {
  getCountryTaxes,
} from 'reduxpath/ducks/CountryTax/List'

import List from './units'

const mapStateToProps = state => ({
  countryTax: state.CountryTaxList,
  data: state.CountryTaxList.data,
  isLoading: state.CountryTaxList.isLoading,
})

const mapDispatchToProps = dispatch => ({
  handlePageChange(key) {
    const limit = 10
    const qs = {
      sort: 'name ASC',
      limit,
      skip: key.selected * limit,
    }
    dispatch(getCountryTaxes(qs))
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(List)
